<template>
    <div class="nav">
      <el-row>
        <el-col :span="4">
            <div class="grid-content bg-purple btn">
          <span class="el-icon-arrow-left" @click="bk()">返回</span>
        </div>
        </el-col>
        <el-col :span="20"><div class="grid-content bg-purple-light nav_s">
            <span v-if="navs=='报表'">报表</span>
            <span v-else-if="navs=='商品库存查询'">商品库存查询</span>
            <span v-else-if="navs=='活动查询'">活动查询</span>
            <span v-else-if="navs=='个人指标完成情况'">个人指标完成情况</span>
            <span v-else-if="navs=='单品销售数量'">个人指标完成情况</span>

        </div></el-col>
      </el-row>
    </div>
</template>

<script>
export default {
  name: "navTars",
  props:{navs: String},
  data(){
      return{
          navs:''
      }
  },
  methods:{
    bk(){
      this.$router.push({path:'/reportIndex'})
    }
  },
}
</script>

<style lang="scss">
  .nav{
    width: 100%;
    height: 45px;
    background-color: white;
  }
  .nav_s{
    width: 100%;
    font-size: 18px;
    color: #4D586D;
    text-align: center;
    line-height: 45px;
    margin-left: -30px;
  }
  .btn{
   line-height: 45px;
    color: #FF9901;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/navTars.vue